"use client";
import { classes } from "@/classnames";
import classNames from "classnames";
import { useState } from "react";
import { FormItem } from "../form-item";
import { ITextarea } from "./textarea.types";

export const TextArea: ITextarea = ({
  label,
  required,
  className,
  error,
  ...rest
}) => {
  const [focused, setFocus] = useState(false);
  const [currentLength, setCurrentLength] = useState(0);

  return (
    <FormItem
      label={label}
      required={required}
      className={classNames(classes.FormItem, className)}
      error={error}
      focused={focused}
    >
      <div className="flex flex-col w-full mt-[12.5px]">
        <textarea
          {...rest}
          rows={4}
          maxLength={500}
          onInput={(e) => setCurrentLength(e.currentTarget.value.length)}
          onFocus={() => setFocus(true)}
          onBlur={(e) => !e.currentTarget.value && setFocus(false)}
          className="w-full border-0 relative z-1 outline-0 text-[18px] font-[800] h-[86px] resize-none pb-[20px]"
        />
        <div className="flex flex-row w-full justify-end">
          <span className="text-text-04 font-[600] font-fustat text-[14px] relative right-[-6px] bottom-[-10px]">
            {currentLength}/500
          </span>
        </div>
      </div>
    </FormItem>
  );
};
